import { ReactNode, useCallback, useState } from "react";
import { NavLink } from "react-router";
import t from "@/lang/lang";
import {
  SampleBaseDataTableFilters,
  useDefaultSampleBaseDataListRequest,
} from "@/services/backend/samples/components/sample-base-data-table";
import { AirMicrobialBaseDataTable } from "@/services/backend/samples/components/air-microbial-base-data-table";
import { CreateAirMicrobialBaseDataDialog } from "@/services/backend/samples/components/create-air-microbial-base-data-dialog";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";

export function AirMicrobialBaseDataListRoute() {
  const [request, setRequest] = useState(useDefaultSampleBaseDataListRequest());

  const renderRowLink = useCallback(
    (baseDataId: string, children: ReactNode) => (
      <NavLink to={baseDataId}>{children}</NavLink>
    ),
    [],
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Luftkeimproben")}</CardTitle>
        <CardDescription>
          {t(
            "Hier können Sie die Vorgabewerte verwalten, mit denen eine neue Luftkeimprobe angelegt wird. Die als aktiv markierten Basisdaten werden dafür verwendet.",
          )}
        </CardDescription>
        <CardAction>
          <CreateAirMicrobialBaseDataDialog />
        </CardAction>
      </CardHeader>
      <CardContent className="grid gap-2">
        <SampleBaseDataTableFilters
          request={request}
          onRequestChange={setRequest}
        />
        <AirMicrobialBaseDataTable
          request={request}
          onRequestChange={setRequest}
          renderRowLink={renderRowLink}
          hideBorder
        />
      </CardContent>
    </Card>
  );
}
